<div class="performance-panel">
	<div class="panel-grid">
		<div class="panel-col">
			<div class="panel-header">
				<h3>Top Performing Hotels</h3>
			</div>

			<app-top-performing-hotels-table
				[rows]="(topRows$ | async) ?? []"
				[loading]="(loading$ | async) ?? false"
				[staffByPropertyId]="(staffByPropertyId$ | async) ?? null"
			></app-top-performing-hotels-table>
		</div>

		<div class="divider"></div>

		<div class="panel-col">
			<div class="panel-header">
				<h3>Under Performing Hotels</h3>
			</div>

			<app-under-performing-hotels-table
				[rows]="(underRows$ | async) ?? []"
				[loading]="(loading$ | async) ?? false"
				[staffByPropertyId]="(staffByPropertyId$ | async) ?? null"
			></app-under-performing-hotels-table>
		</div>
	</div>
</div>
